import { v4 } from 'uuid';
import { TableSettings } from '../TableSettings';
import { EntityType } from '../../comment';
import { translate } from '../../translation/Translator';

export const AssetTableSettingsColumn = {
  productName: 'productName',
  productNumber: 'productNumber',
  availableQuantity: 'availableQuantity',
  quantity: 'quantity',
  assignedTo: 'assignedTo',
  status: 'status',
  serial: 'serial',
} as const;

export type AssetTableSettingsColumn = (typeof AssetTableSettingsColumn)[keyof typeof AssetTableSettingsColumn];

export class AssetTableSettings {
  static default(companyId: string) {
    return new TableSettings<AssetTableSettingsColumn>({
      id: v4(),
      companyId,
      type: EntityType.asset,
      columns: [
        {
          index: 0,
          column: AssetTableSettingsColumn.productName,
          label: translate({ key: AssetTableSettingsColumn.productName }),
        },
        {
          index: 1,
          column: AssetTableSettingsColumn.productNumber,
          label: translate({ key: AssetTableSettingsColumn.productNumber }),
        },
        {
          index: 2,
          column: AssetTableSettingsColumn.serial,
          label: translate({ key: AssetTableSettingsColumn.serial }),
        },
        {
          index: 3,
          column: AssetTableSettingsColumn.assignedTo,
          label: translate({ key: AssetTableSettingsColumn.assignedTo }),
        },
        {
          index: 4,
          column: AssetTableSettingsColumn.status,
          label: translate({ key: AssetTableSettingsColumn.status }),
        },
        {
          index: 5,
          column: AssetTableSettingsColumn.quantity,
          label: translate({ key: AssetTableSettingsColumn.quantity }),
        },
      ],
    });
  }
}
